export const JoinType = {
    LEFT_OUTER: 'LEFT OUTER',
    RIGHT_OUTER: 'RIGHT OUTER',
    FULL_OUTER: 'FULL OUTER',
    INNER: 'INNER'
};

export const JOIN_TYPES = [
    { type: 'INNER', label: 'inner join', icon: 'blend-type-inner' },
    { type: 'LEFT_OUTER', label: 'outer left', icon: 'blend-type-left' },
    { type: 'RIGHT_OUTER', label: 'outer right', icon: 'blend-type-right' },
    { type: 'FULL_OUTER', label: 'full outer join', icon: 'blend-type-full' }
];
